/* nplus-card-deposit.js — <nplus-card-deposit> element.
   Loaded after nplus-deposit-service.js. Uses Stripe.js (global Stripe) + window.nplusDeposit. */
(function () {
  'use strict';

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  // Stripe card/validation errors carry a shopper-facing, localized message; any other

  // Stripe error (bad key, unknown intent, …) is technical and gets the generic text.

  function stripeError(e) {

    var err = new Error((e && e.code) || 'stripe_error');

    if (e && (e.type === 'card_error' || e.type === 'validation_error') && e.message) err.customerMessage = e.message;

    return err;

  }


  class NplusCardDeposit extends HTMLElement {
    connectedCallback() {
      var cfgEl = this.querySelector('.nplus-deposit__config');
      try { this.cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { this.cfg = {}; }

      this.fields = {};
      var self = this;
      Array.prototype.forEach.call(this.querySelectorAll('[data-nplus-field]'), function (el) {
        self.fields[el.getAttribute('data-nplus-field')] = el;
      });
      this.termsEl = this.querySelector('[data-nplus-terms]');
      this.submitEl = this.querySelector('[data-nplus-submit]');
      this.statusEl = this.querySelector('[data-nplus-status]');

      if (this.submitEl) this.submitEl.addEventListener('click', this.onSubmit.bind(this));

      // Mount the Stripe Payment Element up front so the card fields are visible in the
      // deposit flow (design-studio parity), not only after the first submit click.
      // Guarded: only eager-mount once Stripe's globals are present; otherwise onSubmit
      // will call ensureStripe() later (avoids permanently disabling on a load race).
      if (typeof window.Stripe === 'function' && window.nplusDeposit && this.cfg.publishableKey) {
        this.ensureStripe();
      }
    }

    setStatus(msg, isError) {
      if (!this.statusEl) return;
      this.statusEl.textContent = msg || '';
      this.statusEl.hidden = !msg;
      this.statusEl.classList.toggle('nplus-deposit__status--error', !!isError);
    }
    setBusy(busy) {
      if (!this.submitEl) return;
      this.submitEl.disabled = busy;
      this.submitEl.setAttribute('aria-busy', busy ? 'true' : 'false');
      this.submitEl.classList.toggle('is-busy', !!busy);
      // Swap the label for "Processing…" so customers know to wait (spinner via CSS).
      var label = this.submitEl.querySelector('.vw-btn-label');
      if (label) {
        if (busy) { this._idleLabel = label.textContent; label.textContent = this.t('processing', 'Processing…'); }
        else if (this._idleLabel != null) { label.textContent = this._idleLabel; this._idleLabel = null; }
      }
    }
    t(key, fallback) { return (this.cfg && this.cfg.i18n && this.cfg.i18n[key]) || fallback; }

    ensureStripe() {
      if (this._stripeInit) return;
      this._stripeInit = true;
      if (typeof window.Stripe !== 'function' || !window.nplusDeposit || !this.cfg.publishableKey) {
        this.setStatus(this.t('payment_unavailable', 'Payment is temporarily unavailable.'), true);
        if (this.submitEl) this.submitEl.disabled = true;
        return;
      }
      // locale drives the Payment Element's language — a German storefront gets a German card form.
      this.stripe = window.Stripe(this.cfg.publishableKey, { locale: this.cfg.locale || 'auto' });
      this.elements = this.stripe.elements({ mode: 'payment', amount: Math.round(Number(this.cfg.amount)), currency: String(this.cfg.currency || '').toLowerCase(), paymentMethodTypes: ['card'], appearance: { theme: 'stripe' } });
      this.paymentElement = this.elements.create('payment', {
        fields: { billingDetails: { name: 'never', email: 'never', phone: 'never', address: 'never' } }
      });
      this.paymentElement.mount('#nplus-payment-element');
      this.cardReady = false;
      var self = this;
      this.paymentElement.on('change', function (e) { self.cardReady = !!e.complete; });
    }

    readCustomer() {
      var f = this.fields;
      function val(el) { return el ? el.value.trim() : ''; }
      return {
        firstName: val(f.firstName),
        lastName: val(f.lastName),
        email: val(f.email),
        confirmEmail: val(f.confirmEmail),
        phoneCountry: val(f.phoneCountry),
        phoneNumber: val(f.phoneNumber),
        address: val(f.address),
        address2: val(f.address2),
        city: val(f.city),
        state: val(f.state),
        postal: val(f.postal),
        country: val(f.country)
      };
    }

    validate(customer) {
      var errs = {};
      var required = ['firstName', 'lastName', 'email', 'phoneNumber', 'address', 'city', 'postal', 'country'];
      var self = this;
      required.forEach(function (k) {
        if (!customer[k]) errs[k] = self.t('required', 'Required');
      });
      if (customer.email && !EMAIL_RE.test(customer.email)) errs.email = this.t('invalid_email', 'Enter a valid email');
      if (!customer.confirmEmail) errs.confirmEmail = this.t('required', 'Required');
      else if (customer.confirmEmail !== customer.email) errs.confirmEmail = this.t('email_mismatch', 'Email addresses do not match');

      // Every field that has an error node — clear or set it.
      var allFields = ['firstName', 'lastName', 'email', 'confirmEmail', 'phoneCountry', 'phoneNumber', 'address', 'address2', 'city', 'state', 'postal', 'country'];
      allFields.forEach(function (k) {
        var input = self.fields[k];
        var errEl = self.querySelector('[data-nplus-error-for="' + k + '"]');
        if (!input) return;
        if (errs[k]) { input.setAttribute('aria-invalid', 'true'); if (errEl) { errEl.textContent = errs[k]; errEl.hidden = false; } }
        else { input.removeAttribute('aria-invalid'); if (errEl) { errEl.hidden = true; } }
      });
      return Object.keys(errs).length === 0;
    }

    onSubmit() {
      this.setStatus('');
      this.ensureStripe();
      var customer = this.readCustomer();
      if (!this.validate(customer)) return;
      if (!this.termsEl || !this.termsEl.checked) { this.setStatus(this.t('accept_terms', 'Please accept the deposit terms.'), true); return; }
      if (!this.stripe || !this.elements) { this.setStatus(this.t('payment_unavailable', 'Payment is temporarily unavailable.'), true); return; }
      if (!this.cardReady) { this.setStatus(this.t('card_incomplete', 'Please complete your card details.'), true); return; }

      this.setBusy(true);
      var self = this;
      var accessories = (window.nplusAccessories && typeof window.nplusAccessories.getSelection === 'function')
        ? window.nplusAccessories.getSelection() : [];
      window.nplusDeposit.createDepositIntent({
        productId: this.cfg.productId, variantId: this.cfg.variantId, customer: customer, accessories: accessories,
        market: this.cfg.market,
        currency: this.cfg.currency,
        // Sent so the draft order gets the buyer's market (correct currency/tax), not just Stripe.
        billing: {
          address1: customer.address, address2: customer.address2, city: customer.city,
          province: customer.state, zip: customer.postal, country: customer.country
        }
      }).then(function (res) {
        return self.elements.submit().then(function (sub) {
          if (sub && sub.error) throw stripeError(sub.error);
          return self.stripe.confirmPayment({
            elements: self.elements,
            clientSecret: res.clientSecret,
            confirmParams: {
              return_url: self.confirmationUrl(),
              payment_method_data: {
                billing_details: {
                  name: (customer.firstName + ' ' + customer.lastName).trim(),
                  email: customer.email,
                  phone: (customer.phoneCountry || '') + (customer.phoneNumber || ''),
                  address: {
                    line1: customer.address, line2: customer.address2 || '',
                    city: customer.city, state: customer.state,
                    postal_code: customer.postal, country: customer.country
                  }
                }
              }
            },
            redirect: 'if_required'
          });
        });
      }).then(function (result) {
        if (result && result.error) throw stripeError(result.error);
        var pi = result && result.paymentIntent;
        if (pi && pi.id) { window.location.assign(self.confirmationUrl() + '?payment_intent=' + encodeURIComponent(pi.id)); return; }
        self.showSuccess();
      }).catch(function (err) {
        // Never show backend codes (server_error, …); Stripe's own card messages are shopper-facing.
        if (window.console) console.error('[nplus-card-deposit] submit failed', err);
        self.setStatus(err && err.customerMessage ? err.customerMessage : self.t('generic_error', 'Something went wrong. Please try again or contact us.'), true);
        self.setBusy(false);
      });
    }

    // Absolute URL of the deposit confirmation page, locale-prefixed (e.g. /de/pages/…).
    confirmationUrl() {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return window.location.origin + root + 'pages/deposit-confirmation';
    }

    showSuccess() {
      var title = this.t('success_title', 'Deposit received');
      var body = this.t('success_body', 'Thank you — your deposit is confirmed and we will be in touch about your build.');
      this.innerHTML = '<div class="nplus-deposit__success"><h3>' + title + '</h3><p>' + body + '</p></div>';
    }
  }

  if (!customElements.get('nplus-card-deposit')) {
    customElements.define('nplus-card-deposit', NplusCardDeposit);
  }
})();
